// extracted by css-extract-rspack-plugin
export default {"wrapper":"_1861463a","crumb":"_128ff122","crumbLink":"_39cca02"};